export default {
  root: {
    '&:last-child': {
      paddingBottom: 'none',
    },
  },
}
